export default "__VITE_ASSET__2lHLVBKt__"